import * as React from 'react';
import { useSelector } from 'react-redux';
import Button from '../_common/button';
import Modal from '../_common/modal';
import { cn, get, getConfig, getText } from '../../helpers';
import keyPages from '../../utilities/key-pages';
import RequestTrialFormProvider from '../_providers/rat-form-provider/rat-form-provider';

function getVariant(productVariant: string, productId: string): string {
    const productVariantFirstCharUpperCase = () => {
        const arr = productVariant.split('');
        arr[0] = arr[0].toUpperCase();
        return arr.join('');
    };
    const config: { IdVariant: any[] } = useSelector((state: RootStoreState) => get(state, 'shared.config.data', false))[productVariantFirstCharUpperCase()];
    if (config && productId && config.IdVariant && config.IdVariant.some((variant: IdVariant) => variant && variant.Id.includes(productId))) {
        return config.IdVariant.filter((variant: IdVariant) => variant.Id.includes(productId))[0].Variant;
    }
    return productVariant;
}

const defaultVariantDataset = {
    buttonText: getText('generic.requestTrial'),
    buttonTitle: getText('generic.tryOutThisDataset')
};

const defaultVariantSolution = {
    buttonText: getText('generic.requestMoreInformation'),
    buttonTitle: getText('generic.tryOutThisSolution')
};

const defaultVariantBlueprint = {
    buttonText: getText('generic.requestMoreInformation'),
    buttonTitle: getText('generic.tryOutThisBlueprint')
};

const defaultVariantQRSolution = {
    buttonText: getText('generic.requestMoreInformation'),
    buttonTitle: getText('generic.qrSolutionRequestMoreInformation')
};

const defaultVariantCommuniqueSolution = {
    buttonText: getText('generic.requestMoreInformation'),
    buttonTitle: getText('generic.qrSolutionRequestMoreInformation')
};

const buttonVariants: RequestATrialButtonText = {
    solution: defaultVariantSolution,
    blueprint: defaultVariantBlueprint,
    default: defaultVariantDataset,
    qrsolution: defaultVariantQRSolution,
    communique: defaultVariantCommuniqueSolution
};


function getKeyPageId(productVariant: string): keyPages {
    if (productVariant === 'solution') {
        return keyPages.solutionRATForm;
    }
    return keyPages.datasetRATForm;
}


function RequestTrialButton(props: RequestTrialButtonProps) {
    const [modalIsOpen, setModalOpen] = React.useState<boolean>(false);
    const { productVariant, productId = '', className, productName = '', isXLButton, dataProvider, buttonText, marketMSADataLink, dataFilePath, marketplaceMSATooltip, metaData } = props;
    const headerVariant = getVariant(productVariant, productId);
    const customText = buttonVariants[headerVariant] || buttonVariants[productVariant] || buttonVariants.default;
    // console.log('rat_button:metaData:', metaData);

    return (
        <>
            <Button
                text={buttonText || customText.buttonText}
                title={isXLButton ? customText.buttonTitle : ''}
                onClick={() => setModalOpen(true)}
                hasIcon={isXLButton}
                theme="primary"
                isFullWidth
                gtmId="rat-form-load"
                className={cn('rta-btn', { 'rta-btn--xl': isXLButton }, className)}
            />
            <Modal
                open={modalIsOpen}
                onClose={() => setModalOpen(false)}
                isFullScreen={window.innerWidth < 1024}
                scrollBody
                keyPageId={getKeyPageId(productVariant)}
                title="request more information"
            >
                <RequestTrialFormProvider dataProvider={dataProvider} productVariant={productVariant} productName={productName} productId={productId} titleText={buttonText} marketMSADataLink={marketMSADataLink} dataFilePath={dataFilePath} marketplaceMSATooltip={marketplaceMSATooltip} metaData={metaData} />
            </Modal>
        </>
    );
}

export default React.memo(RequestTrialButton);
